import { Model } from '@vuex-orm/core';
import MontageListItemAPI from '@/modules/Logistics/api/controllers/MontageListItemAPI';
import { MontageItemCreatePayload, MontageItemUpdatePayload } from '@/modules/Logistics/interfaces/LogisticsInterfaces';

/**
 * MontageListItem model for items inside a montage list
 */
export default class MontageListItem extends Model {
    public id!: string;
    public montage_list_id!: string;
    public position!: number;
    public projectConnection!: string | null;
    public user!: string | null;
    public workDescription!: string | null;
    public contact!: string | null;
    public place!: string | null;
    public projectDocument!: string | null;
    public documentNumber!: string | null;
    public system!: string | null;
    public plannedStart!: string | null;
    public plannedEnd!: string | null;
    public inProduction!: string | null;
    public manufactured!: string | null;
    public productionStatus!: string | null;
    public createdAt!: string;
    public updatedAt!: string;

    public static entity = 'montage_list_items';

    public static fields() {
        return {
            id: this.attr(null),
            montage_list_id: this.attr(null),
            position: this.number(0),
            projectConnection: this.attr(null),
            user: this.attr(null),
            workDescription: this.attr(null),
            contact: this.attr(null),
            place: this.attr(null),
            projectDocument: this.attr(null),
            documentNumber: this.attr(null),
            system: this.attr(null),
            plannedStart: this.attr(null),
            plannedEnd: this.attr(null),
            inProduction: this.attr(null),
            manufactured: this.attr(null),
            productionStatus: this.attr(null),
            createdAt: this.attr(null),
            updatedAt: this.attr(null),
        };
    }

    public static async fetchByMontageListId(montageListId: string): Promise<MontageListItem[]> {
        try {
            const response = await MontageListItemAPI.getByMontageListId(montageListId);
            const items = response?.data || [];
            await MontageListItem.insertOrUpdate({ data: items });
            return items;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async createNew(montageListId: string, itemData: MontageItemCreatePayload): Promise<MontageListItem> {
        try {
            const response = await MontageListItemAPI.create(montageListId, itemData);
            const item = response?.data;
            if (item) {
                await MontageListItem.insertOrUpdate({ data: item });
            }
            return item;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async updateExisting(id: string, itemData: MontageItemUpdatePayload): Promise<MontageListItem> {
        try {
            const response = await MontageListItemAPI.update(id, itemData);
            const item = response?.data;
            if (item) {
                await MontageListItem.insertOrUpdate({ data: item });
            }
            return item;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    public static async deleteExisting(id: string): Promise<void> {
        try {
            await MontageListItemAPI.delete(id);
            await MontageListItem.delete(id);
        } catch (e) {
            return Promise.reject(e);
        }
    }
}
